var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2 gap-4"},[_c('bar-chart',{staticClass:"col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4",attrs:{"chart-data":_vm.clientsPerMonth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }